export default __webpack_public_path__ + "static/media/mask_group_16-33.64b7c545.png";